import { Label } from "./ui/label";
import { X } from "@phosphor-icons/react";
import { ClientePicker, nomeCliente as nome } from "./ClientePicker";

/** Selettore con ricerca di altri committenti (comproprietari) dall'anagrafica clienti, in ordine alfabetico per cognome. */
export default function AltriClientiPicker({ clienti, principaleId, value = [], onChange, onCreato, label = "Altri committenti (opzionale)", testId = "altri-clienti-picker" }) {
  const disponibili = clienti.filter((c) => c.id !== principaleId && !value.includes(c.id));
  const scelti = value.map((id) => clienti.find((c) => c.id === id)).filter(Boolean);

  return (
    <div className="space-y-2" data-testid={testId}>
      <Label>{label}</Label>
      <ClientePicker clienti={disponibili} value="" onChange={(id) => { if (id) onChange([...value, id]); }} vuotoLabel="" onCreato={onCreato} disabled={!disponibili.length && !onCreato}
        placeholder={disponibili.length ? "Aggiungi un altro committente…" : "Nessun altro cliente disponibile"} testId={`${testId}-select`} />
      {scelti.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {scelti.map((c) => (
            <span key={c.id} className="inline-flex items-center gap-1 text-xs bg-slate-900 text-white rounded-full pl-2.5 pr-1 py-0.5" data-testid={`altro-cliente-chip-${c.id}`}>
              {nome(c)}
              <button type="button" onClick={() => onChange(value.filter((x) => x !== c.id))} className="rounded-full hover:bg-white/20 p-0.5" aria-label={`Rimuovi ${nome(c)}`} data-testid={`altro-cliente-rimuovi-${c.id}`}>
                <X size={11} />
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export const nomiCommittenti = (clienti, doc) => {
  const ids = [doc.cliente_id, ...(doc.altri_clienti_ids || [])].filter(Boolean);
  const nomi = ids.map((id) => clienti.find((c) => c.id === id)).filter(Boolean).map(nome);
  return nomi.length ? nomi.join(" + ") : "—";
};
